import { LanguagesEnum } from '../../../../config/languages';

const CONFIGURATION = {};

export const Translations = {
  header: {
    [LanguagesEnum.English]: 'VAT Amount (Total from all Supplies)',
    [LanguagesEnum.Greek]: 'VAT Amount (Total from all Supplies)',
  },
  part1: {
    [LanguagesEnum.English]: 'Total VAT Amount for ',
    [LanguagesEnum.Greek]: 'Total VAT Amount for ',
  },
  part2: {
    [LanguagesEnum.English]: ' and ',
    [LanguagesEnum.Greek]: ' and ',
  },
  part3: {
    [LanguagesEnum.English]: ' to all Member States of Consumption (€):',
    [LanguagesEnum.Greek]: ' to all Member States of Consumption (€):',
  },
  services: {
    [LanguagesEnum.English]: 'Services',
    [LanguagesEnum.Greek]: 'Services',
  },
  goods: {
    [LanguagesEnum.English]: 'Goods',
    [LanguagesEnum.Greek]: 'Goods',
  },
};

export default CONFIGURATION;
